import styled from 'styled-components'

export const StyledSVG = styled.svg`
  #up .cls-100,
  #down .cls-100 {
    transition: all 0.3s ease;
  }

  #up:hover {
    cursor: ${p => (p.highestfloor ? 'not-allowed' : 'pointer')};
    padding: 20px;

    .cls-100 {
      fill: ${p => (p.highestfloor ? '#e6e7e8' : 'var(--brand-green-color)')};
    }
  }

  #down:hover {
    cursor: ${p => (p.lowestfloor ? 'not-allowed' : 'pointer')};
    padding: 20px;

    .cls-100 {
      fill: ${p => (p.lowestfloor ? '#e6e7e8' : 'var(--brand-green-color)')};
    }
  }

  .active-apt {
    fill: var(--brand-green-color);
    cursor: pointer;
  }

  .active-balcony {
    fill: var(--brand-primary-color);
    cursor: pointer;
  }

  .on-hover {
    fill: var(--brand-green-color);
    cursor: pointer;
  }

  .on-hover-balcony {
    fill: var(--brand-primary-color);
    cursor: pointer;
  }

  .white-text .cls-2 {
    fill: var(--light);
    cursor: pointer;
  }

  .green-text .cls-2 {
    fill: var(--green-color);
    cursor: pointer;
  }

  .switch {
    cursor: pointer;
  }

  .disabled {
    pointer-events: none;
    cursor: not-allowed;
  }

  .sold {
    fill: var(--color-sold);
    pointer-events: none;
  }

  .reserved {
    fill: #deb254;
  }

  .text-white-sold path {
    fill: #fff;
    pointer-events: none;
  }

  #apartment_nr g {
    cursor: pointer;
  }
`

export default function SVG({
  id,
  viewBox,
  children,
  highestFloor,
  lowestFloor,
}) {
  return (
    <StyledSVG
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={viewBox}
      highestfloor={Boolean(highestFloor) ? 'true' : undefined}
      lowestfloor={Boolean(lowestFloor) ? 'true' : undefined}
    >
      {children}
    </StyledSVG>
  )
}
